import React from 'react';
import { useTranslation } from 'react-i18next';

import { getQuestionPermalink } from '../utils/functions';

const Permalink = ({ question }) => {
  const { i18n } = useTranslation();
  const locale = i18n.language;

  return question && <a className="permalink" href={getQuestionPermalink(locale, question)} title={question.question}>
    <i className='icon icon--link'></i>
  </a>;
}

export default Permalink;
